<template>
  <section>
    <form method="post" @submit.prevent="send">
      <form-wrapper :validator="$v.form">
        <form-group
          horizontal
          name="active"
          :label="$t('attributes.activation_status')"
        >
          <b-switch v-model="form.active" name="active"></b-switch>
        </form-group>

        <b-field horizontal :label="$t('attributes.activation_type')">
          <b-input v-model="type_name" disabled expanded></b-input>
        </b-field>

        <b-field horizontal :label="$t('attributes.collaborate')">
          <b-input v-model="collaborate_name" disabled expanded></b-input>
        </b-field>

        <form-group horizontal name="name" :label="$t('attributes.name')">
          <b-input
            v-model="form.name"
            @input="$v.form.name.$touch()"
            name="name"
            :placeholder="$t('message.please_input') + $t('attributes.name')"
            expanded
          >
          </b-input>
        </form-group>

        <form-group
          horizontal
          name="is_fill_order_detail"
          :label="$t('attributes.is_fill_order_detail')"
        >
          <b-switch
            v-model="form.is_fill_order_detail"
            name="is_fill_order_detail"
          ></b-switch>
        </form-group>

        <form-group
          horizontal
          name="show_remainder_quantity"
          :label="$t('attributes.show_remainder_quantity')"
        >
          <b-switch
            v-model="form.show_remainder_quantity"
            name="show_remainder_quantity"
          ></b-switch>
        </form-group>

        <form-group
          horizontal
          name="show_sign_up_quantity"
          :label="$t('attributes.show_sign_up_quantity')"
        >
          <b-switch
            v-model="form.show_sign_up_quantity"
            name="show_sign_up_quantity"
          ></b-switch>
        </form-group>

        <form-group
          horizontal
          name="show_quota_free"
          :label="$t('attributes.show_quota_free')"
        >
          <b-switch
            v-model="form.show_quota_free"
            name="show_quota_free"
          ></b-switch>
        </form-group>

        <form-group
          horizontal
          name="show_quota_free_remained"
          :label="$t('attributes.show_quota_free_remained')"
        >
          <b-switch
            v-model="form.show_quota_free_remained"
            name="show_quota_free_remained"
          ></b-switch>
        </form-group>

        <form-group
          horizontal
          name="show_quota_free_total"
          :label="$t('attributes.show_quota_free_total')"
        >
          <b-switch
            v-model="form.show_quota_free_total"
            name="show_quota_free_total"
          ></b-switch>
        </form-group>

        <form-group
          horizontal
          name="show_download_files"
          :label="$t('attributes.show_download_files')"
        >
          <b-switch
            v-model="form.show_download_files"
            name="show_download_files"
          ></b-switch>
        </form-group>

        <form-group
          horizontal
          name="show_doc_file"
          :label="$t('attributes.show_doc_file')"
        >
          <b-switch
            v-model="form.show_doc_file"
            name="show_doc_file"
          ></b-switch>
        </form-group>

        <form-group
          horizontal
          name="show_orientation_url"
          :label="$t('attributes.show_orientation_url')"
        >
          <b-switch
            v-model="form.show_orientation_url"
            name="show_orientation_url"
          ></b-switch>
        </form-group>

        <form-group
          horizontal
          name="show_menu_url"
          :label="$t('attributes.show_menu_url')"
        >
          <b-switch
            v-model="form.show_menu_url"
            name="show_menu_url"
          ></b-switch>
        </form-group>

        <form-group
          horizontal
          name="show_product_feature"
          :label="$t('attributes.show_product_feature')"
        >
          <b-switch
            v-model="form.show_product_feature"
            name="show_product_feature"
          ></b-switch>
        </form-group>

        <form-group
          horizontal
          name="show_total_fee"
          :label="$t('attributes.show_total_fee')"
        >
          <b-switch
            v-model="form.show_total_fee"
            name="show_total_fee"
          ></b-switch>
        </form-group>

        <form-group
          horizontal
          name="show_bed_type"
          :label="$t('attributes.show_bed_type')"
        >
          <b-switch
            v-model="form.show_bed_type"
            name="show_bed_type"
          ></b-switch>
        </form-group>

        <form-group
          horizontal
          name="open_spot"
          :label="$t('attributes.open_spot')"
        >
          <b-switch v-model="form.open_spot" name="open_spot"></b-switch>
        </form-group>

        <form-group
          horizontal
          name="can_cancel_order"
          :label="$t('attributes.can_cancel_order')"
        >
          <b-switch
            v-model="form.can_cancel_order"
            name="can_cancel_order"
          ></b-switch>
        </form-group>

        <form-group
          horizontal
          name="only_show_specify_group"
          :label="$t('attributes.only_show_specify_group')"
        >
          <b-switch
            v-model="form.only_show_specify_group"
            name="only_show_specify_group"
          ></b-switch>
        </form-group>

        <form-group
          horizontal
          name="only_view_specify_group"
          :label="$t('attributes.only_view_specify_group')"
        >
          <b-switch
            v-model="form.only_view_specify_group"
            name="only_view_specify_group"
          ></b-switch>
        </form-group>

        <b-field horizontal grouped>
          <template #label>
            {{ $t('attributes.activity_cover') }}
            <b-tooltip type="is-dark" label="720x380/限定jpg檔，100KB內">
              <b-icon size="is-small" icon="help-circle-outline"></b-icon>
            </b-tooltip>
          </template>
          <b-field class="file">
            <a class="button is-primary" @click="onSelectCoverImage">
              <b-icon icon="upload"></b-icon>
              <span>{{ $t('message.please_select_file') }}</span>
            </a>
            <p
              v-if="form.cover"
              class="tag is-warning"
              style="margin-left: 4px; height: 36px"
            >
              <a
                :href="collaborateActivityImage(form.cover)"
                @click.prevent="onClickImage(form.cover)"
              >
                {{ form.cover }}
              </a>
            </p>
          </b-field>
        </b-field>

        <b-field horizontal>
          <b-button :loading="sending" type="is-primary" native-type="submit">
            {{ $t('attributes.update') }}
          </b-button>
        </b-field>
      </form-wrapper>
    </form>

    <b-modal :active.sync="isImageModalActive">
      <p class="image">
        <img :src="collaborateActivityImage(selectedImageUrl)" alt="" />
      </p>
    </b-modal>
  </section>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators'
import { OpenCollaborateActivityFinder } from '@/utils/ckfinder'
import notifyService from '@/services/notifyService'

export default {
  name: 'ActivityBasicForm',

  props: {
    sending: {
      type: Boolean,
      default: true
    },
    id: {
      type: Number,
      default: null
    },
    active: {
      type: Boolean,
      default: true
    },
    type: {
      type: Number,
      default: null
    },
    // eslint-disable-next-line vue/prop-name-casing
    is_fill_order_detail: {
      type: Boolean,
      default: true
    },
    // eslint-disable-next-line vue/prop-name-casing
    show_remainder_quantity: {
      type: Boolean,
      default: true
    },
    // eslint-disable-next-line vue/prop-name-casing
    show_sign_up_quantity: {
      type: Boolean,
      default: true
    },
    // eslint-disable-next-line vue/prop-name-casing
    show_quota_free: {
      type: Boolean,
      default: true
    },
    // eslint-disable-next-line vue/prop-name-casing
    show_quota_free_remained: {
      type: Boolean,
      default: true
    },
    // eslint-disable-next-line vue/prop-name-casing
    show_quota_free_total: {
      type: Boolean,
      default: true
    },
    // eslint-disable-next-line vue/prop-name-casing
    show_download_files: {
      type: Boolean,
      default: true
    },
    // eslint-disable-next-line vue/prop-name-casing
    show_doc_file: {
      type: Boolean,
      default: true
    },
    // eslint-disable-next-line vue/prop-name-casing
    show_orientation_url: {
      type: Boolean,
      default: true
    },
    // eslint-disable-next-line vue/prop-name-casing
    show_menu_url: {
      type: Boolean,
      default: true
    },
    // eslint-disable-next-line vue/prop-name-casing
    show_product_feature: {
      type: Boolean,
      default: true
    },
    // eslint-disable-next-line vue/prop-name-casing
    show_total_fee: {
      type: Boolean,
      default: true
    },
    // eslint-disable-next-line vue/prop-name-casing
    show_bed_type: {
      type: Boolean,
      default: true
    },
    // eslint-disable-next-line vue/prop-name-casing
    open_spot: {
      type: Boolean,
      default: true
    },
    // eslint-disable-next-line vue/prop-name-casing
    can_cancel_order: {
      type: Boolean,
      default: false
    },
    // eslint-disable-next-line vue/prop-name-casing
    only_show_specify_group: {
      type: Boolean,
      default: true
    },
    // eslint-disable-next-line vue/prop-name-casing
    only_view_specify_group: {
      type: Boolean,
      default: false
    },
    // eslint-disable-next-line vue/prop-name-casing
    collaborate_id: {
      type: Number,
      default: null
    },
    // eslint-disable-next-line vue/prop-name-casing
    collaborate_name: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    cover: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      type_name: this.ActivityTypeName(this.type),
      form: {
        id: this.id,
        active: this.active,
        collaborate_id: this.collaborate_id,
        name: this.name,
        is_fill_order_detail: this.is_fill_order_detail,
        show_remainder_quantity: this.show_remainder_quantity,
        show_sign_up_quantity: this.show_sign_up_quantity,
        show_quota_free: this.show_quota_free,
        show_quota_free_remained: this.show_quota_free_remained,
        show_quota_free_total: this.show_quota_free_total,
        show_download_files: this.show_download_files,
        show_doc_file: this.show_doc_file,
        show_orientation_url: this.show_orientation_url,
        show_menu_url: this.show_menu_url,
        show_product_feature: this.show_product_feature,
        show_total_fee: this.show_total_fee,
        show_bed_type: this.show_bed_type,
        open_spot: this.open_spot,
        can_cancel_order: this.can_cancel_order,
        only_show_specify_group: this.only_show_specify_group,
        only_view_specify_group: this.only_view_specify_group,
        cover: this.cover
      },
      isImageModalActive: false,
      selectedImageUrl: null
    }
  },
  validations: {
    form: {
      name: { required, maxLength: maxLength(50) }
    }
  },
  watch: {
    id() {
      this.type_name = this.ActivityTypeName(this.type)
      this.form = {
        id: this.id,
        active: this.active,
        collaborate_id: this.collaborate_id,
        name: this.name,
        is_fill_order_detail: this.is_fill_order_detail,
        show_remainder_quantity: this.show_remainder_quantity,
        show_sign_up_quantity: this.show_sign_up_quantity,
        show_quota_free: this.show_quota_free,
        show_quota_free_remained: this.show_quota_free_remained,
        show_quota_free_total: this.show_quota_free_total,
        show_download_files: this.show_download_files,
        show_doc_file: this.show_doc_file,
        show_orientation_url: this.show_orientation_url,
        show_menu_url: this.show_menu_url,
        show_product_feature: this.show_product_feature,
        show_total_fee: this.show_total_fee,
        show_bed_type: this.show_bed_type,
        open_spot: this.open_spot,
        can_cancel_order: this.can_cancel_order,
        only_show_specify_group: this.only_show_specify_group,
        only_view_specify_group: this.only_view_specify_group,
        cover: this.cover
      }
    }
  },
  methods: {
    async onSelectCoverImage() {
      try {
        this.form.cover = await OpenCollaborateActivityFinder()
      } catch (e) {
        notifyService.error(e)
      }
    },
    onClickImage(url) {
      this.isImageModalActive = true
      this.selectedImageUrl = url
    },
    async send() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      this.$emit('onSend', this.form)
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-card {
  min-height: 480px;
}
</style>
